<template>
    <BlocksAnimation>
        <RichText :text="block.Text" />

        <div
            v-if="block?.Buttons?.length"
            class="mt-6 flex flex-wrap items-center gap-2"
            :class="{
                'justify-center': block.ButtonAlignment === 'centred',
            }"
        >
            <NuxtLink
                v-for="(button, index) in block.Buttons"
                :key="index"
                :href="button.url"
                :target="button.target"
                :title="button.title"
            >
                <DButton :theme="buttonTheme(button.buttonStyle)" size="lg">
                    {{ button.text }}
                </DButton>
            </NuxtLink>
        </div>
    </BlocksAnimation>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'

    const { buttonTheme } = useButtonTheme()

    defineProps({
        id: String,
        block: Object,
    })

</script>

<style lang="scss" scoped>
    .prose {
        --tw-prose-headings: var(--text-neutral-base);
    }
</style>